import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Tooltip from 'components/widgets/overlays/tooltip';


export default function MenuAlert({ className, children, ...props }) {
  return (
    <Tooltip
      placement="bottom"
      className={classNames('menu-alert', 'badge', className)}
      tooltipClasses="menu-tooltip"
      {...props}
    >
      {children}
    </Tooltip>
  );
}

MenuAlert.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};
